/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApprovePartnerJoinRequestDto } from '../../models/approve-partner-join-request-dto';
import { PartnerJoinRequestDto } from '../../models/partner-join-request-dto';

export interface PartnerJoinRequestControllerApproveJoinRequest$Params {

/**
 * 파트너사 요청 ID
 */
  joinId: string;

/**
 * 워크스페이스 ID
 */
  id: any;
      body: ApprovePartnerJoinRequestDto
}

export function partnerJoinRequestControllerApproveJoinRequest(http: HttpClient, rootUrl: string, params: PartnerJoinRequestControllerApproveJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerJoinRequestDto>> {
  const rb = new RequestBuilder(rootUrl, partnerJoinRequestControllerApproveJoinRequest.PATH, 'patch');
  if (params) {
    rb.path('joinId', params.joinId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerJoinRequestDto>;
    })
  );
}

partnerJoinRequestControllerApproveJoinRequest.PATH = '/api/partner-join-request/{id}/join/{joinId}/approve';
